import "./Pricing.module.css";
import Header from "@/reusable_sections/Header";
import Pricing from "./sections/Pricing";
import Products from "./sections/Products";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function PricingPage() {
  return <div>
      <Header />
      <Pricing />
      <Products />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}